require('./salons.scss')

module.exports = {
  template: require('./salons.pug')()
  controller: require('./salons.ctrl')
}
